import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ArrowDropUpRounded, ArrowDropDownRounded } from '@mui/icons-material';
import { colors } from '../theme/theme';

export interface StatCardProps {
  icon: React.ReactElement;
  color: string;
  value: React.ReactNode;
  label: string;
  trend?: { dir: 'up' | 'down'; text: string };
}

/** KPI stat card — compact horizontal: tinted icon left, label/value/trend stacked right. */
const StatCard: React.FC<StatCardProps> = ({ icon, color, value, label, trend }) => (
  <Paper sx={{ p: 1.75, display: 'flex', alignItems: 'center', gap: 1.5, height: '100%' }}>
    <Box sx={{ flexShrink: 0, width: 40, height: 40, borderRadius: '11px', display: 'grid', placeItems: 'center', bgcolor: color + '1F', color, '& svg': { fontSize: 20 } }}>
      {icon}
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ color: colors.textSecondary, fontSize: 12, fontWeight: 500, lineHeight: 1.3 }} noWrap>{label}</Typography>
      <Typography sx={{ fontSize: 22, fontWeight: 800, letterSpacing: '-.02em', lineHeight: 1.2 }} noWrap>{value}</Typography>
      {trend && (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', fontSize: 11, fontWeight: 600, color: trend.dir === 'down' ? colors.error : colors.success }}>
          {trend.dir === 'down' ? <ArrowDropDownRounded /> : <ArrowDropUpRounded />}
          {trend.text}
        </Box>
      )}
    </Box>
  </Paper>
);

export default StatCard;
